//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class SituWarpApiClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    addArtifact(request) {
        let url_ = this.baseUrl + "/api/artifact-store/add-artifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddArtifact(_response);
        });
    }
    processAddArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteArtifact(request) {
        let url_ = this.baseUrl + "/api/artifact-store/delete-artifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteArtifact(_response);
        });
    }
    processDeleteArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setArtifactActive(request) {
        let url_ = this.baseUrl + "/api/artifact-store/set-artifact-active";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetArtifactActive(_response);
        });
    }
    processSetArtifactActive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetArtifactActiveResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setArtifactFileCountExpected(request) {
        let url_ = this.baseUrl + "/api/artifact-store/set-artifactfile-count-expected";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetArtifactFileCountExpected(_response);
        });
    }
    processSetArtifactFileCountExpected(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetArtifactFileCountExpectedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setArtifactFileCountExpectedSync(request) {
        let url_ = this.baseUrl + "/api/artifact-store/set-artifactfile-count-expected-sync";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetArtifactFileCountExpectedSync(_response);
        });
    }
    processSetArtifactFileCountExpectedSync(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetArtifactFileCountExpectedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifact(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-artifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifact(_response);
        });
    }
    processGetArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactLatestVersion(callerReferenceKey) {
        let url_ = this.baseUrl + "/api/artifact-store/get-artifact-latest-version?";
        if (callerReferenceKey !== undefined && callerReferenceKey !== null)
            url_ += "callerReferenceKey=" + encodeURIComponent("" + callerReferenceKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactLatestVersion(_response);
        });
    }
    processGetArtifactLatestVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactsByReferenceKey(callerReferenceKey) {
        let url_ = this.baseUrl + "/api/artifact-store/get-artifacts-by-reference-key?";
        if (callerReferenceKey !== undefined && callerReferenceKey !== null)
            url_ += "callerReferenceKey=" + encodeURIComponent("" + callerReferenceKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactsByReferenceKey(_response);
        });
    }
    processGetArtifactsByReferenceKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/search-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchArtifacts(_response);
        });
    }
    processSearchArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchManyArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/search-many-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchManyArtifacts(_response);
        });
    }
    processSearchManyArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    pagedSearchArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/paged-search-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPagedSearchArtifacts(_response);
        });
    }
    processPagedSearchArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PagedSearchArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listDistinctMetaDataValuesByKey(request) {
        let url_ = this.baseUrl + "/api/artifact-store/list-distinct-metadata-value-by-key";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListDistinctMetaDataValuesByKey(_response);
        });
    }
    processListDistinctMetaDataValuesByKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListDistinctMetaDataValuesByKeyResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addArtifactFileRecord(request) {
        let url_ = this.baseUrl + "/api/artifact-store/add-artifact-file-record";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddArtifactFileRecord(_response);
        });
    }
    processAddArtifactFileRecord(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddArtifactFileRecordResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactFileRecords(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-artifact-file-records";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactFileRecords(_response);
        });
    }
    processGetArtifactFileRecords(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactFileRecordsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifacts(_response);
        });
    }
    processGetArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSourceArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-source-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSourceArtifacts(_response);
        });
    }
    processGetSourceArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateArtifactMetaData(request) {
        let url_ = this.baseUrl + "/api/artifact-store/update-artifact-metadata";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateArtifactMetaData(_response);
        });
    }
    processUpdateArtifactMetaData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateMetaDataResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteArtifactFileRecord(request) {
        let url_ = this.baseUrl + "/api/artifact-store/delete-artifact-file-record";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteArtifactFileRecord(_response);
        });
    }
    processDeleteArtifactFileRecord(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteArtifactFileRecordResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDependentArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-dependent-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDependentArtifacts(_response);
        });
    }
    processGetDependentArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDependentArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getManyDependentArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/get-many-dependent-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetManyDependentArtifacts(_response);
        });
    }
    processGetManyDependentArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDependentArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    purgeArtifacts(request) {
        let url_ = this.baseUrl + "/api/artifact-store/purge-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPurgeArtifacts(_response);
        });
    }
    processPurgeArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurgeArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFile(request) {
        let url_ = this.baseUrl + "/api/artifact-store-file/get-file";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFile(_response);
        });
    }
    processGetFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addFile(callerReferenceKey, version, fileName, files) {
        let url_ = this.baseUrl + "/api/artifact-store-file/add-file";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (callerReferenceKey !== null && callerReferenceKey !== undefined)
            content_.append("callerReferenceKey", callerReferenceKey.toString());
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("version", version.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("fileName", fileName.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddFile(_response);
        });
    }
    processAddFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addChunkedFile(callerReferenceKey, version, id, fileName, totalChunkCount, chunkIndex, fileSize, files) {
        let url_ = this.baseUrl + "/api/artifact-store-file/add-chunked-file";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (callerReferenceKey !== null && callerReferenceKey !== undefined)
            content_.append("callerReferenceKey", callerReferenceKey.toString());
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("version", version.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("id", id.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("fileName", fileName.toString());
        if (totalChunkCount === null || totalChunkCount === undefined)
            throw new Error("The parameter 'totalChunkCount' cannot be null.");
        else
            content_.append("totalChunkCount", totalChunkCount.toString());
        if (chunkIndex === null || chunkIndex === undefined)
            throw new Error("The parameter 'chunkIndex' cannot be null.");
        else
            content_.append("chunkIndex", chunkIndex.toString());
        if (fileSize === null || fileSize === undefined)
            throw new Error("The parameter 'fileSize' cannot be null.");
        else
            content_.append("fileSize", fileSize.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddChunkedFile(_response);
        });
    }
    processAddChunkedFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddChunkedFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFileList(request) {
        let url_ = this.baseUrl + "/api/artifact-store-file/get-file-list";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFileList(_response);
        });
    }
    processGetFileList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFileListResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    purgeArtifactFiles(request) {
        let url_ = this.baseUrl + "/api/artifact-store-file/purge-artifact-files";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPurgeArtifactFiles(_response);
        });
    }
    processPurgeArtifactFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurgeArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCompanies() {
        let url_ = this.baseUrl + "/api/asset-catalog/get-companies";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanies(_response);
        });
    }
    processGetCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCompaniesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetInstancesByCompany(request) {
        let url_ = this.baseUrl + "/api/asset-catalog/get-assetinstances-by-company";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetInstancesByCompany(_response);
        });
    }
    processGetAssetInstancesByCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetResourcesByCompany(request) {
        let url_ = this.baseUrl + "/api/asset-catalog/get-assetresources-by-company";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetResourcesByCompany(_response);
        });
    }
    processGetAssetResourcesByCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetTemplates() {
        let url_ = this.baseUrl + "/api/asset-catalog/get-assettemplates";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetTemplates(_response);
        });
    }
    processGetAssetTemplates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactVersions(request) {
        let url_ = this.baseUrl + "/api/asset-catalog/get-artifact-versions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactVersions(_response);
        });
    }
    processGetArtifactVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactVersionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    healthCheck() {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processHealthCheck(_response);
        });
    }
    processHealthCheck(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(HealthCheck.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    ping() {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPing(_response);
        });
    }
    processPing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBuilders() {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-builders";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetBuilders(_response);
        });
    }
    processGetBuilders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBuildersResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomesByBuilder(request) {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-homes-by-builder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomesByBuilder(_response);
        });
    }
    processGetHomesByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomesByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getMasterFilesByHome(request) {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-masterfiles-by-home";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMasterFilesByHome(_response);
        });
    }
    processGetMasterFilesByHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMasterFilesByHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getOptionsByHome(request) {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-options-by-home";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetOptionsByHome(_response);
        });
    }
    processGetOptionsByHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOptionsByHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getThemesByBuilder(request) {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-themes-by-builder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetThemesByBuilder(_response);
        });
    }
    processGetThemesByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetThemesByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getIfcProductsByBuilder(request) {
        let url_ = this.baseUrl + "/api/ifc-catalog/get-ifcproducts-by-builder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetIfcProductsByBuilder(_response);
        });
    }
    processGetIfcProductsByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetIfcProductsByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listFacadeConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/FacadeConfig/list-facade-configs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListFacadeConfigs(_response);
        });
    }
    processListFacadeConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListFacadeConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listFacadeConfigVersions(request) {
        let url_ = this.baseUrl + "/api/queries/FacadeConfig/list-facade-config-versions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListFacadeConfigVersions(_response);
        });
    }
    processListFacadeConfigVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListFacadeConfigVersionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFacadeConfig(request) {
        let url_ = this.baseUrl + "/api/queries/FacadeConfig/get-facade-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFacadeConfig(_response);
        });
    }
    processGetFacadeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFacadeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getIfcSettings(request) {
        let url_ = this.baseUrl + "/api/queries/GetIfcSettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetIfcSettings(_response);
        });
    }
    processGetIfcSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetIfcSettingsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPagedCompanyDetails(request) {
        let url_ = this.baseUrl + "/api/queries/GetPagedCompanyDetails/get-paged-company-details";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetPagedCompanyDetails(_response);
        });
    }
    processGetPagedCompanyDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPagedCompanyDetailsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPlacementSettings(request) {
        let url_ = this.baseUrl + "/api/queries/GetPlacementSettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetPlacementSettings(_response);
        });
    }
    processGetPlacementSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPlacementSettingsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductReplacementTheme(request) {
        let url_ = this.baseUrl + "/api/queries/GetProductReplacementTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductReplacementTheme(_response);
        });
    }
    processGetProductReplacementTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductReplacementThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getVanityConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetVanityConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetVanityConfig(_response);
        });
    }
    processGetVanityConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetVanityConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listArtifacts(request) {
        let url_ = this.baseUrl + "/api/queries/list-artifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListArtifacts(_response);
        });
    }
    processListArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleOptions(request) {
        let url_ = this.baseUrl + "/api/queries/ListStyleOptions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleOptions(_response);
        });
    }
    processListStyleOptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleOptionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listVanityConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/ListVanityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListVanityConfigs(_response);
        });
    }
    processListVanityConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListVanityConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listVanityConfigVersions(request) {
        let url_ = this.baseUrl + "/api/queries/ListVanityConfigVersions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListVanityConfigVersions(_response);
        });
    }
    processListVanityConfigVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListVanityConfigVersionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleChoicesConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/StyleChoicesConfig/list-style-choices-configs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleChoicesConfigs(_response);
        });
    }
    processListStyleChoicesConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleChoicesConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleChoicesConfigVersions(request) {
        let url_ = this.baseUrl + "/api/queries/StyleChoicesConfig/list-style-choices-config-versions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleChoicesConfigVersions(_response);
        });
    }
    processListStyleChoicesConfigVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleChoicesConfigVersionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleChoicesConfig(request) {
        let url_ = this.baseUrl + "/api/queries/StyleChoicesConfig/get-style-choices-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleChoicesConfig(_response);
        });
    }
    processGetStyleChoicesConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleChoicesConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteVanityConfig(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteVanityConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteVanityConfig(_response);
        });
    }
    processDeleteVanityConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteVanityConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveFacadeConfig(request) {
        let url_ = this.baseUrl + "/api/commands/FacadeConfig/save-facade-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveFacadeConfig(_response);
        });
    }
    processSaveFacadeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveFacadeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteFacadeConfig(request) {
        let url_ = this.baseUrl + "/api/commands/FacadeConfig/delete-facade-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteFacadeConfig(_response);
        });
    }
    processDeleteFacadeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteFacadeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveIfcSettings(request) {
        let url_ = this.baseUrl + "/api/commands/SaveIfcSettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveIfcSettings(_response);
        });
    }
    processSaveIfcSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveIfcSettingsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    savePlacementSettings(request) {
        let url_ = this.baseUrl + "/api/commands/SavePlacementSettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSavePlacementSettings(_response);
        });
    }
    processSavePlacementSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SavePlacementSettingsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveProductReplacementTheme(request) {
        let url_ = this.baseUrl + "/api/commands/SaveProductReplacementTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveProductReplacementTheme(_response);
        });
    }
    processSaveProductReplacementTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveProductReplacementThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveVanityConfig(request) {
        let url_ = this.baseUrl + "/api/commands/SaveVanityConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveVanityConfig(_response);
        });
    }
    processSaveVanityConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveVanityConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveStyleChoicesConfig(request) {
        let url_ = this.baseUrl + "/api/commands/StyleChoicesConfig/save-style-choices-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveStyleChoicesConfig(_response);
        });
    }
    processSaveStyleChoicesConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveStyleChoicesConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteStyleChoicesConfig(request) {
        let url_ = this.baseUrl + "/api/commands/StyleChoicesConfig/delete-style-choices-config";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteStyleChoicesConfig(_response);
        });
    }
    processDeleteStyleChoicesConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteStyleChoicesConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SituResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class AddArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class AddArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.inActive = _data["inActive"];
            this.fingerPrint = _data["fingerPrint"];
            this.fileCountExpected = _data["fileCountExpected"];
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(ArtifactVersionReference.fromJS(item));
            }
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["inActive"] = this.inActive;
        data["fingerPrint"] = this.fingerPrint;
        data["fileCountExpected"] = this.fileCountExpected;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        return data;
    }
}
export class ArtifactVersionReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.path = _data["path"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersionReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["path"] = this.path;
        return data;
    }
}
export class MetaData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}
export class DeleteArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class DeleteArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        return data;
    }
}
export class SetArtifactActiveResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactActiveResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetArtifactActiveRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactActiveRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["active"] = this.active;
        return data;
    }
}
export class SetArtifactFileCountExpectedResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactFileCountExpectedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetArtifactFileCountExpectedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.fileCountExpected = _data["fileCountExpected"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactFileCountExpectedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["fileCountExpected"] = this.fileCountExpected;
        return data;
    }
}
export class GetArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifact = _data["artifact"] ? Artifact.fromJS(_data["artifact"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifact"] = this.artifact ? this.artifact.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class Artifact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.active = _data["active"];
            this.fingerPrint = _data["fingerPrint"];
            this.isDeleted = _data["isDeleted"];
            this.fileCountExpected = _data["fileCountExpected"];
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(ArtifactVersionReference.fromJS(item));
            }
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(ArtifactFile.fromJS(item));
            }
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Artifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["active"] = this.active;
        data["fingerPrint"] = this.fingerPrint;
        data["isDeleted"] = this.isDeleted;
        data["fileCountExpected"] = this.fileCountExpected;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        return data;
    }
}
export class ArtifactFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.artifactCallerReferenceKey = _data["artifactCallerReferenceKey"];
            this.artifactVersion = _data["artifactVersion"];
            this.fileName = _data["fileName"];
            this.relativePath = _data["relativePath"];
            this.fileUrl = _data["fileUrl"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artifactCallerReferenceKey"] = this.artifactCallerReferenceKey;
        data["artifactVersion"] = this.artifactVersion;
        data["fileName"] = this.fileName;
        data["relativePath"] = this.relativePath;
        data["fileUrl"] = this.fileUrl;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        return data;
    }
}
export class GetArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.artifactId = _data["artifactId"];
            this.returnFiles = _data["returnFiles"];
            this.returnMetaData = _data["returnMetaData"];
            this.returnSourceArtifacts = _data["returnSourceArtifacts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["artifactId"] = this.artifactId;
        data["returnFiles"] = this.returnFiles;
        data["returnMetaData"] = this.returnMetaData;
        data["returnSourceArtifacts"] = this.returnSourceArtifacts;
        return data;
    }
}
export class GetArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(Artifact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class SearchArtifactsRequestBase {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateTimeBefore = _data["dateTimeBefore"] ? new Date(_data["dateTimeBefore"].toString()) : undefined;
            this.excludeDeleted = _data["excludeDeleted"];
            this.includeInactive = _data["includeInactive"];
            this.returnLatestOnly = _data["returnLatestOnly"];
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(ArtifactVersionReference.fromJS(item));
            }
            if (Array.isArray(_data["sourceArtifactCallerReferenceKeys"])) {
                this.sourceArtifactCallerReferenceKeys = [];
                for (let item of _data["sourceArtifactCallerReferenceKeys"])
                    this.sourceArtifactCallerReferenceKeys.push(item);
            }
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
            this.getSourceArtifactsToLevel = _data["getSourceArtifactsToLevel"];
            this.returnFiles = _data["returnFiles"];
            this.returnMetaData = _data["returnMetaData"];
            this.returnSourceArtifacts = _data["returnSourceArtifacts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchArtifactsRequestBase();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeBefore"] = this.dateTimeBefore ? this.dateTimeBefore.toISOString() : undefined;
        data["excludeDeleted"] = this.excludeDeleted;
        data["includeInactive"] = this.includeInactive;
        data["returnLatestOnly"] = this.returnLatestOnly;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceArtifactCallerReferenceKeys)) {
            data["sourceArtifactCallerReferenceKeys"] = [];
            for (let item of this.sourceArtifactCallerReferenceKeys)
                data["sourceArtifactCallerReferenceKeys"].push(item);
        }
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        data["getSourceArtifactsToLevel"] = this.getSourceArtifactsToLevel;
        data["returnFiles"] = this.returnFiles;
        data["returnMetaData"] = this.returnMetaData;
        data["returnSourceArtifacts"] = this.returnSourceArtifacts;
        return data;
    }
}
export class SearchArtifactsRequest extends SearchArtifactsRequestBase {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.fingerPrint = _data["fingerPrint"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["fingerPrint"] = this.fingerPrint;
        super.toJSON(data);
        return data;
    }
}
export class SearchManyArtifactsRequest extends SearchArtifactsRequestBase {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["callerReferenceKeys"])) {
                this.callerReferenceKeys = [];
                for (let item of _data["callerReferenceKeys"])
                    this.callerReferenceKeys.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchManyArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callerReferenceKeys)) {
            data["callerReferenceKeys"] = [];
            for (let item of this.callerReferenceKeys)
                data["callerReferenceKeys"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfArtifact extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Artifact.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfArtifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class PagedSearchArtifactsResponse extends PagedResponseOfArtifact {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSearchArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PagedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
export class PagedSearchArtifactsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.fingerPrint = _data["fingerPrint"];
            this.dateTimeBefore = _data["dateTimeBefore"] ? new Date(_data["dateTimeBefore"].toString()) : undefined;
            this.excludeDeleted = _data["excludeDeleted"];
            this.includeInactive = _data["includeInactive"];
            this.returnLatestOnly = _data["returnLatestOnly"];
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(ArtifactVersionReference.fromJS(item));
            }
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedSearchArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["fingerPrint"] = this.fingerPrint;
        data["dateTimeBefore"] = this.dateTimeBefore ? this.dateTimeBefore.toISOString() : undefined;
        data["excludeDeleted"] = this.excludeDeleted;
        data["includeInactive"] = this.includeInactive;
        data["returnLatestOnly"] = this.returnLatestOnly;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListDistinctMetaDataValuesByKeyResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [];
                for (let item of _data["values"])
                    this.values.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListDistinctMetaDataValuesByKeyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class ListDistinctMetaDataValuesByKeyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["artifactMetaDataFilter"])) {
                this.artifactMetaDataFilter = [];
                for (let item of _data["artifactMetaDataFilter"])
                    this.artifactMetaDataFilter.push(MetaData.fromJS(item));
            }
            this.dateTimeBefore = _data["dateTimeBefore"] ? new Date(_data["dateTimeBefore"].toString()) : undefined;
            this.excludeDeleted = _data["excludeDeleted"];
            this.includeInactive = _data["includeInactive"];
            this.returnLatestOnly = _data["returnLatestOnly"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListDistinctMetaDataValuesByKeyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.artifactMetaDataFilter)) {
            data["artifactMetaDataFilter"] = [];
            for (let item of this.artifactMetaDataFilter)
                data["artifactMetaDataFilter"].push(item.toJSON());
        }
        data["dateTimeBefore"] = this.dateTimeBefore ? this.dateTimeBefore.toISOString() : undefined;
        data["excludeDeleted"] = this.excludeDeleted;
        data["includeInactive"] = this.includeInactive;
        data["returnLatestOnly"] = this.returnLatestOnly;
        return data;
    }
}
export class AddArtifactFileRecordResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddArtifactFileRecordResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AddArtifactFileRecordRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactFile = _data["artifactFile"] ? ArtifactFile.fromJS(_data["artifactFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddArtifactFileRecordRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactFile"] = this.artifactFile ? this.artifactFile.toJSON() : undefined;
        return data;
    }
}
export class GetArtifactFileRecordsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(ArtifactFileModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactFileRecordsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactFileModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactFileModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}
export class GetArtifactFileRecordsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactFileRecordsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class GetArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(ArtifactVersionReference.fromJS(item));
            }
            this.getSourceArtifactsToLevel = _data["getSourceArtifactsToLevel"];
            this.returnFiles = _data["returnFiles"];
            this.returnMetaData = _data["returnMetaData"];
            this.returnSourceArtifacts = _data["returnSourceArtifacts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        data["getSourceArtifactsToLevel"] = this.getSourceArtifactsToLevel;
        data["returnFiles"] = this.returnFiles;
        data["returnMetaData"] = this.returnMetaData;
        data["returnSourceArtifacts"] = this.returnSourceArtifacts;
        return data;
    }
}
export class GetSourceArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(Artifact.fromJS(item));
            }
            this.getSourceArtifactsToLevel = _data["getSourceArtifactsToLevel"];
            this.returnFiles = _data["returnFiles"];
            this.returnMetaData = _data["returnMetaData"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourceArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        data["getSourceArtifactsToLevel"] = this.getSourceArtifactsToLevel;
        data["returnFiles"] = this.returnFiles;
        data["returnMetaData"] = this.returnMetaData;
        return data;
    }
}
export class UpdateMetaDataResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMetaDataResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class UpdateMetaDataRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.artifactId = _data["artifactId"];
            this.updateAction = _data["updateAction"];
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMetaDataRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["artifactId"] = this.artifactId;
        data["updateAction"] = this.updateAction;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        return data;
    }
}
export var Action;
(function (Action) {
    Action[Action["Replace"] = 0] = "Replace";
    Action[Action["Append"] = 1] = "Append";
    Action[Action["AppendOrSet"] = 2] = "AppendOrSet";
})(Action || (Action = {}));
export class DeleteArtifactFileRecordResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArtifactFileRecordResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteArtifactFileRecordRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactFile = _data["artifactFile"] ? ArtifactFile.fromJS(_data["artifactFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArtifactFileRecordRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactFile"] = this.artifactFile ? this.artifactFile.toJSON() : undefined;
        return data;
    }
}
export class GetDependentArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tooManyDependencies = _data["tooManyDependencies"];
            if (Array.isArray(_data["artifactVersions"])) {
                this.artifactVersions = [];
                for (let item of _data["artifactVersions"])
                    this.artifactVersions.push(ArtifactVersionReference.fromJS(item));
            }
            this.purgeConfirmationHash = _data["purgeConfirmationHash"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDependentArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tooManyDependencies"] = this.tooManyDependencies;
        if (Array.isArray(this.artifactVersions)) {
            data["artifactVersions"] = [];
            for (let item of this.artifactVersions)
                data["artifactVersions"].push(item.toJSON());
        }
        data["purgeConfirmationHash"] = this.purgeConfirmationHash;
        super.toJSON(data);
        return data;
    }
}
export class GetDependentArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.artifactId = _data["artifactId"];
            this.includeRequestedSourceArtifactInResults = _data["includeRequestedSourceArtifactInResults"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDependentArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["artifactId"] = this.artifactId;
        data["includeRequestedSourceArtifactInResults"] = this.includeRequestedSourceArtifactInResults;
        return data;
    }
}
export class GetManyDependentArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.includeRequestedSourceArtifactsInResults = _data["includeRequestedSourceArtifactsInResults"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetManyDependentArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["includeRequestedSourceArtifactsInResults"] = this.includeRequestedSourceArtifactsInResults;
        return data;
    }
}
export class PurgeArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PurgeArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["artifactVersions"])) {
                this.artifactVersions = [];
                for (let item of _data["artifactVersions"])
                    this.artifactVersions.push(ArtifactVersionReference.fromJS(item));
            }
            this.purgeConfirmationHash = _data["purgeConfirmationHash"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifactVersions)) {
            data["artifactVersions"] = [];
            for (let item of this.artifactVersions)
                data["artifactVersions"].push(item.toJSON());
        }
        data["purgeConfirmationHash"] = this.purgeConfirmationHash;
        return data;
    }
}
export class GetFileRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["fileName"] = this.fileName;
        return data;
    }
}
export class AddFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        super.toJSON(data);
        return data;
    }
}
export class AddChunkedFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fileUrl = _data["fileUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddChunkedFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        super.toJSON(data);
        return data;
    }
}
export class GetFileListResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifactFiles"])) {
                this.artifactFiles = [];
                for (let item of _data["artifactFiles"])
                    this.artifactFiles.push(ArtifactFileModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileListResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifactFiles)) {
            data["artifactFiles"] = [];
            for (let item of this.artifactFiles)
                data["artifactFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetFileListRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileListRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class GetCompaniesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [];
                for (let item of _data["companies"])
                    this.companies.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompaniesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetAssetInstancesByCompanyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.templateName = _data["templateName"];
            this.searchString = _data["searchString"];
            this.excludeDeleted = _data["excludeDeleted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetInstancesByCompanyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["templateName"] = this.templateName;
        data["searchString"] = this.searchString;
        data["excludeDeleted"] = this.excludeDeleted;
        return data;
    }
}
export class GetAssetResourcesByCompanyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.resourceType = _data["resourceType"];
            this.searchString = _data["searchString"];
            this.excludeDeleted = _data["excludeDeleted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetResourcesByCompanyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["resourceType"] = this.resourceType;
        data["searchString"] = this.searchString;
        data["excludeDeleted"] = this.excludeDeleted;
        return data;
    }
}
export class GetArtifactVersionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [];
                for (let item of _data["results"])
                    this.results.push(ArtifactVersionReference.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactVersionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactEnvironment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.environment = _data["environment"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactEnvironment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["environment"] = this.environment;
        data["product"] = this.product;
        return data;
    }
}
export var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName[EnvironmentName["Latest"] = 0] = "Latest";
    EnvironmentName[EnvironmentName["Staging"] = 1] = "Staging";
    EnvironmentName[EnvironmentName["Production"] = 2] = "Production";
    EnvironmentName[EnvironmentName["Fallback"] = 3] = "Fallback";
})(EnvironmentName || (EnvironmentName = {}));
export var ProductName;
(function (ProductName) {
    ProductName[ProductName["Panorama"] = 0] = "Panorama";
    ProductName[ProductName["VR"] = 1] = "VR";
    ProductName[ProductName["RayTraced"] = 2] = "RayTraced";
    ProductName[ProductName["Plan"] = 3] = "Plan";
    ProductName[ProductName["Render"] = 4] = "Render";
    ProductName[ProductName["Facade"] = 5] = "Facade";
    ProductName[ProductName["Insights"] = 6] = "Insights";
    ProductName[ProductName["Vanity"] = 7] = "Vanity";
    ProductName[ProductName["AssetModule"] = 8] = "AssetModule";
    ProductName[ProductName["RayTracedPlus"] = 9] = "RayTracedPlus";
    ProductName[ProductName["ProductPreview"] = 10] = "ProductPreview";
    ProductName[ProductName["IfcPreview"] = 11] = "IfcPreview";
    ProductName[ProductName["Connect"] = 12] = "Connect";
    ProductName[ProductName["Unreal"] = 13] = "Unreal";
})(ProductName || (ProductName = {}));
export class GetArtifactVersionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            if (Array.isArray(_data["callerReferenceKeys"])) {
                this.callerReferenceKeys = [];
                for (let item of _data["callerReferenceKeys"])
                    this.callerReferenceKeys.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactVersionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        if (Array.isArray(this.callerReferenceKeys)) {
            data["callerReferenceKeys"] = [];
            for (let item of this.callerReferenceKeys)
                data["callerReferenceKeys"].push(item);
        }
        return data;
    }
}
export class HealthCheck {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.service = _data["service"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheck();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}
export class GetBuildersResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["builders"])) {
                this.builders = [];
                for (let item of _data["builders"])
                    this.builders.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.builders)) {
            data["builders"] = [];
            for (let item of this.builders)
                data["builders"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetHomesByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homes"])) {
                this.homes = [];
                for (let item of _data["homes"])
                    this.homes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomesByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homes)) {
            data["homes"] = [];
            for (let item of this.homes)
                data["homes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetHomesByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomesByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["builder"] = this.builder;
        return data;
    }
}
export class GetMasterFilesByHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["masterFiles"])) {
                this.masterFiles = [];
                for (let item of _data["masterFiles"])
                    this.masterFiles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterFilesByHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.masterFiles)) {
            data["masterFiles"] = [];
            for (let item of this.masterFiles)
                data["masterFiles"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetMasterFilesByHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.builder = _data["builder"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterFilesByHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["builder"] = this.builder;
        data["home"] = this.home;
        return data;
    }
}
export class GetOptionsByHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOptionsByHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetOptionsByHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.builder = _data["builder"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOptionsByHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["builder"] = this.builder;
        data["home"] = this.home;
        return data;
    }
}
export class GetThemesByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(item);
            }
            if (Array.isArray(_data["decoratorThemes"])) {
                this.decoratorThemes = [];
                for (let item of _data["decoratorThemes"])
                    this.decoratorThemes.push(item);
            }
            if (Array.isArray(_data["furnishingThemes"])) {
                this.furnishingThemes = [];
                for (let item of _data["furnishingThemes"])
                    this.furnishingThemes.push(item);
            }
            if (Array.isArray(_data["furnishingPlacementSchemes"])) {
                this.furnishingPlacementSchemes = [];
                for (let item of _data["furnishingPlacementSchemes"])
                    this.furnishingPlacementSchemes.push(item);
            }
            if (Array.isArray(_data["productReplacementThemes"])) {
                this.productReplacementThemes = [];
                for (let item of _data["productReplacementThemes"])
                    this.productReplacementThemes.push(item);
            }
            if (Array.isArray(_data["sceneryThemes"])) {
                this.sceneryThemes = [];
                for (let item of _data["sceneryThemes"])
                    this.sceneryThemes.push(item);
            }
            if (Array.isArray(_data["parameterThemes"])) {
                this.parameterThemes = [];
                for (let item of _data["parameterThemes"])
                    this.parameterThemes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemesByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        if (Array.isArray(this.decoratorThemes)) {
            data["decoratorThemes"] = [];
            for (let item of this.decoratorThemes)
                data["decoratorThemes"].push(item);
        }
        if (Array.isArray(this.furnishingThemes)) {
            data["furnishingThemes"] = [];
            for (let item of this.furnishingThemes)
                data["furnishingThemes"].push(item);
        }
        if (Array.isArray(this.furnishingPlacementSchemes)) {
            data["furnishingPlacementSchemes"] = [];
            for (let item of this.furnishingPlacementSchemes)
                data["furnishingPlacementSchemes"].push(item);
        }
        if (Array.isArray(this.productReplacementThemes)) {
            data["productReplacementThemes"] = [];
            for (let item of this.productReplacementThemes)
                data["productReplacementThemes"].push(item);
        }
        if (Array.isArray(this.sceneryThemes)) {
            data["sceneryThemes"] = [];
            for (let item of this.sceneryThemes)
                data["sceneryThemes"].push(item);
        }
        if (Array.isArray(this.parameterThemes)) {
            data["parameterThemes"] = [];
            for (let item of this.parameterThemes)
                data["parameterThemes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetThemesByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemesByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["builder"] = this.builder;
        return data;
    }
}
export class GetIfcProductsByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcProductsByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetIfcProductsByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcProductsByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["builder"] = this.builder;
        return data;
    }
}
export class ListFacadeConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facadeConfigs"])) {
                this.facadeConfigs = [];
                for (let item of _data["facadeConfigs"])
                    this.facadeConfigs.push(FacadeConfigSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListFacadeConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facadeConfigs)) {
            data["facadeConfigs"] = [];
            for (let item of this.facadeConfigs)
                data["facadeConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class FacadeConfigSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FacadeConfigSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        return data;
    }
}
export class ListFacadeConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListFacadeConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        return data;
    }
}
export class ListFacadeConfigVersionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["versions"])) {
                this.versions = [];
                for (let item of _data["versions"])
                    this.versions.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListFacadeConfigVersionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.version = _data["version"];
            this.isProduction = _data["isProduction"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["version"] = this.version;
        data["isProduction"] = this.isProduction;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        return data;
    }
}
export class ListFacadeConfigVersionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.facadeConfigName = _data["facadeConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListFacadeConfigVersionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["facadeConfigName"] = this.facadeConfigName;
        return data;
    }
}
export class GetFacadeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.facadeConfig = _data["facadeConfig"] ? FacadeConfig.fromJS(_data["facadeConfig"]) : undefined;
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFacadeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["facadeConfig"] = this.facadeConfig ? this.facadeConfig.toJSON() : undefined;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class FacadeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (let item of _data["photos"])
                    this.photos.push(SituPhoto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FacadeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        return data;
    }
}
export class SituPhoto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.lookFrom = _data["lookFrom"] ? SituPhotoFacadePosition.fromJS(_data["lookFrom"]) : undefined;
            this.lookAt = _data["lookAt"] ? SituPhotoFacadePosition.fromJS(_data["lookAt"]) : undefined;
            this.imageWidth = _data["imageWidth"];
            this.imageHeight = _data["imageHeight"];
            this.imageQuality = _data["imageQuality"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituPhoto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lookFrom"] = this.lookFrom ? this.lookFrom.toJSON() : undefined;
        data["lookAt"] = this.lookAt ? this.lookAt.toJSON() : undefined;
        data["imageWidth"] = this.imageWidth;
        data["imageHeight"] = this.imageHeight;
        data["imageQuality"] = this.imageQuality;
        return data;
    }
}
export class SituPhotoPosition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.xOffset = _data["xOffset"];
            this.yOffset = _data["yOffset"];
            this.zOffset = _data["zOffset"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituPhotoPosition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["xOffset"] = this.xOffset;
        data["yOffset"] = this.yOffset;
        data["zOffset"] = this.zOffset;
        return data;
    }
}
export class SituPhotoFacadePosition extends SituPhotoPosition {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.dolly = _data["dolly"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituPhotoFacadePosition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dolly"] = this.dolly;
        super.toJSON(data);
        return data;
    }
}
export class GetFacadeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.facadeConfigName = _data["facadeConfigName"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFacadeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["facadeConfigName"] = this.facadeConfigName;
        data["version"] = this.version;
        return data;
    }
}
export class GetIfcSettingsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.settings = _data["settings"] ? IfcToJsonSettings.fromJS(_data["settings"]) : undefined;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [];
                for (let item of _data["rooms"])
                    this.rooms.push(item);
            }
            if (Array.isArray(_data["storeys"])) {
                this.storeys = [];
                for (let item of _data["storeys"])
                    this.storeys.push(item);
            }
            if (Array.isArray(_data["buildingMaterials"])) {
                this.buildingMaterials = [];
                for (let item of _data["buildingMaterials"])
                    this.buildingMaterials.push(item);
            }
            if (Array.isArray(_data["furnishings"])) {
                this.furnishings = [];
                for (let item of _data["furnishings"])
                    this.furnishings.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcSettingsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item);
        }
        if (Array.isArray(this.storeys)) {
            data["storeys"] = [];
            for (let item of this.storeys)
                data["storeys"].push(item);
        }
        if (Array.isArray(this.buildingMaterials)) {
            data["buildingMaterials"] = [];
            for (let item of this.buildingMaterials)
                data["buildingMaterials"].push(item);
        }
        if (Array.isArray(this.furnishings)) {
            data["furnishings"] = [];
            for (let item of this.furnishings)
                data["furnishings"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class IfcToJsonSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            if (Array.isArray(_data["roomSettings"])) {
                this.roomSettings = [];
                for (let item of _data["roomSettings"])
                    this.roomSettings.push(IfcToJsonRoomSettings.fromJS(item));
            }
            if (Array.isArray(_data["buildingMaterialSettings"])) {
                this.buildingMaterialSettings = [];
                for (let item of _data["buildingMaterialSettings"])
                    this.buildingMaterialSettings.push(IfcToJsonBuildingMaterialSettings.fromJS(item));
            }
            if (Array.isArray(_data["storeySettings"])) {
                this.storeySettings = [];
                for (let item of _data["storeySettings"])
                    this.storeySettings.push(IfcToJsonStoreySettings.fromJS(item));
            }
            if (Array.isArray(_data["furnishingSettings"])) {
                this.furnishingSettings = [];
                for (let item of _data["furnishingSettings"])
                    this.furnishingSettings.push(IfcToJsonFurnishingSettings.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcToJsonSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        if (Array.isArray(this.roomSettings)) {
            data["roomSettings"] = [];
            for (let item of this.roomSettings)
                data["roomSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.buildingMaterialSettings)) {
            data["buildingMaterialSettings"] = [];
            for (let item of this.buildingMaterialSettings)
                data["buildingMaterialSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.storeySettings)) {
            data["storeySettings"] = [];
            for (let item of this.storeySettings)
                data["storeySettings"].push(item.toJSON());
        }
        if (Array.isArray(this.furnishingSettings)) {
            data["furnishingSettings"] = [];
            for (let item of this.furnishingSettings)
                data["furnishingSettings"].push(item.toJSON());
        }
        return data;
    }
}
export class IfcToJsonRoomSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roomName = _data["roomName"];
            this.roomType = _data["roomType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcToJsonRoomSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        data["roomType"] = this.roomType;
        return data;
    }
}
export var RoomType;
(function (RoomType) {
    RoomType[RoomType["NotSet"] = 0] = "NotSet";
    RoomType[RoomType["MasterBedroom"] = 1] = "MasterBedroom";
    RoomType[RoomType["Bedroom"] = 2] = "Bedroom";
    RoomType[RoomType["Family"] = 3] = "Family";
    RoomType[RoomType["Living"] = 4] = "Living";
    RoomType[RoomType["Rumpus"] = 5] = "Rumpus";
    RoomType[RoomType["Media"] = 6] = "Media";
    RoomType[RoomType["Meals"] = 7] = "Meals";
    RoomType[RoomType["MealsAndRumpus"] = 8] = "MealsAndRumpus";
    RoomType[RoomType["MealsAndLiving"] = 9] = "MealsAndLiving";
    RoomType[RoomType["MealsAndFamily"] = 10] = "MealsAndFamily";
    RoomType[RoomType["Garage"] = 11] = "Garage";
    RoomType[RoomType["Alfresco"] = 12] = "Alfresco";
    RoomType[RoomType["Study"] = 13] = "Study";
    RoomType[RoomType["Kids"] = 14] = "Kids";
    RoomType[RoomType["Robe"] = 15] = "Robe";
    RoomType[RoomType["Laundry"] = 16] = "Laundry";
    RoomType[RoomType["Entry"] = 17] = "Entry";
    RoomType[RoomType["Passage"] = 18] = "Passage";
    RoomType[RoomType["Kitchen"] = 19] = "Kitchen";
    RoomType[RoomType["Ensuite"] = 20] = "Ensuite";
    RoomType[RoomType["Linen"] = 21] = "Linen";
    RoomType[RoomType["Pantry"] = 22] = "Pantry";
    RoomType[RoomType["Porch"] = 23] = "Porch";
    RoomType[RoomType["Bath"] = 24] = "Bath";
    RoomType[RoomType["WC"] = 25] = "WC";
    RoomType[RoomType["Balcony"] = 26] = "Balcony";
    RoomType[RoomType["WalkInLinen"] = 27] = "WalkInLinen";
    RoomType[RoomType["Stairwell"] = 28] = "Stairwell";
    RoomType[RoomType["Landing"] = 29] = "Landing";
    RoomType[RoomType["Gym"] = 30] = "Gym";
    RoomType[RoomType["Storeroom"] = 31] = "Storeroom";
    RoomType[RoomType["Activity"] = 32] = "Activity";
    RoomType[RoomType["Mudroom"] = 33] = "Mudroom";
    RoomType[RoomType["OutdoorSpace"] = 34] = "OutdoorSpace";
    RoomType[RoomType["WalkInPantry"] = 35] = "WalkInPantry";
    RoomType[RoomType["Powder"] = 36] = "Powder";
    RoomType[RoomType["Nook"] = 37] = "Nook";
    RoomType[RoomType["Storage"] = 38] = "Storage";
    RoomType[RoomType["WalkInRobe"] = 39] = "WalkInRobe";
})(RoomType || (RoomType = {}));
export class IfcToJsonBuildingMaterialSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.buildingMaterialName = _data["buildingMaterialName"];
            this.buildingMaterialType = _data["buildingMaterialType"];
            this.buildingMaterialTag = _data["buildingMaterialTag"];
            this.shouldAddToTheme = _data["shouldAddToTheme"];
            this.isBrick = _data["isBrick"];
            this.shouldCreateSkirtingAndCornice = _data["shouldCreateSkirtingAndCornice"];
            this.filterMeshWithThisMaterial = _data["filterMeshWithThisMaterial"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcToJsonBuildingMaterialSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["buildingMaterialName"] = this.buildingMaterialName;
        data["buildingMaterialType"] = this.buildingMaterialType;
        data["buildingMaterialTag"] = this.buildingMaterialTag;
        data["shouldAddToTheme"] = this.shouldAddToTheme;
        data["isBrick"] = this.isBrick;
        data["shouldCreateSkirtingAndCornice"] = this.shouldCreateSkirtingAndCornice;
        data["filterMeshWithThisMaterial"] = this.filterMeshWithThisMaterial;
        return data;
    }
}
export var BuildingMaterialType;
(function (BuildingMaterialType) {
    BuildingMaterialType[BuildingMaterialType["NotSet"] = 0] = "NotSet";
    BuildingMaterialType[BuildingMaterialType["Brick"] = 1] = "Brick";
    BuildingMaterialType[BuildingMaterialType["Frame"] = 2] = "Frame";
    BuildingMaterialType[BuildingMaterialType["Void"] = 3] = "Void";
    BuildingMaterialType[BuildingMaterialType["Plasterboard"] = 4] = "Plasterboard";
    BuildingMaterialType[BuildingMaterialType["Cladding"] = 5] = "Cladding";
    BuildingMaterialType[BuildingMaterialType["Concrete"] = 6] = "Concrete";
    BuildingMaterialType[BuildingMaterialType["Tile"] = 7] = "Tile";
    BuildingMaterialType[BuildingMaterialType["Laminate"] = 8] = "Laminate";
    BuildingMaterialType[BuildingMaterialType["PolystyreneRendered"] = 9] = "PolystyreneRendered";
    BuildingMaterialType[BuildingMaterialType["BrickRendered"] = 10] = "BrickRendered";
    BuildingMaterialType[BuildingMaterialType["Error"] = 11] = "Error";
})(BuildingMaterialType || (BuildingMaterialType = {}));
export class IfcToJsonStoreySettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.storeyName = _data["storeyName"];
            this.storeyLevel = _data["storeyLevel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcToJsonStoreySettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["storeyName"] = this.storeyName;
        data["storeyLevel"] = this.storeyLevel;
        return data;
    }
}
export var StoreyLevel;
(function (StoreyLevel) {
    StoreyLevel[StoreyLevel["NotSet"] = 0] = "NotSet";
    StoreyLevel[StoreyLevel["GroundFloor"] = 1] = "GroundFloor";
    StoreyLevel[StoreyLevel["GroundFloorCeiling"] = 2] = "GroundFloorCeiling";
    StoreyLevel[StoreyLevel["FirstFloor"] = 3] = "FirstFloor";
    StoreyLevel[StoreyLevel["FirstFloorCeiling"] = 4] = "FirstFloorCeiling";
    StoreyLevel[StoreyLevel["SubFloor"] = 5] = "SubFloor";
    StoreyLevel[StoreyLevel["Roof"] = 6] = "Roof";
    StoreyLevel[StoreyLevel["Outdoors"] = 7] = "Outdoors";
})(StoreyLevel || (StoreyLevel = {}));
export class IfcToJsonFurnishingSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.furnishingName = _data["furnishingName"];
            this.furnishingTag = _data["furnishingTag"];
            this.productClassificationId = _data["productClassificationId"];
            this.productTypeId = _data["productTypeId"];
            if (Array.isArray(_data["productSpecificationIds"])) {
                this.productSpecificationIds = [];
                for (let item of _data["productSpecificationIds"])
                    this.productSpecificationIds.push(item);
            }
            this.productNumber = _data["productNumber"];
            this.productFacingFlipped = _data["productFacingFlipped"];
            this.productHandednessFlipped = _data["productHandednessFlipped"];
            this.toBeRemoved = _data["toBeRemoved"];
            this.doNotReplace = _data["doNotReplace"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcToJsonFurnishingSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["furnishingName"] = this.furnishingName;
        data["furnishingTag"] = this.furnishingTag;
        data["productClassificationId"] = this.productClassificationId;
        data["productTypeId"] = this.productTypeId;
        if (Array.isArray(this.productSpecificationIds)) {
            data["productSpecificationIds"] = [];
            for (let item of this.productSpecificationIds)
                data["productSpecificationIds"].push(item);
        }
        data["productNumber"] = this.productNumber;
        data["productFacingFlipped"] = this.productFacingFlipped;
        data["productHandednessFlipped"] = this.productHandednessFlipped;
        data["toBeRemoved"] = this.toBeRemoved;
        data["doNotReplace"] = this.doNotReplace;
        return data;
    }
}
export class GetIfcSettingsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.includeRooms = _data["includeRooms"];
            this.includeStoreys = _data["includeStoreys"];
            this.includeBuildingMaterials = _data["includeBuildingMaterials"];
            this.includeFurnishings = _data["includeFurnishings"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcSettingsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["includeRooms"] = this.includeRooms;
        data["includeStoreys"] = this.includeStoreys;
        data["includeBuildingMaterials"] = this.includeBuildingMaterials;
        data["includeFurnishings"] = this.includeFurnishings;
        return data;
    }
}
export class PagedResponseOfCompanyDetails extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CompanyDetails.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfCompanyDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class GetPagedCompanyDetailsResponse extends PagedResponseOfCompanyDetails {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagedCompanyDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CompanyDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}
export class GetPagedCompanyDetailsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagedCompanyDetailsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetPlacementSettingsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.settings = _data["settings"] ? PlacementSettings.fromJS(_data["settings"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlacementSettingsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class PlacementSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["preplacedFurnishings"])) {
                this.preplacedFurnishings = [];
                for (let item of _data["preplacedFurnishings"])
                    this.preplacedFurnishings.push(PreplacedFurnishing.fromJS(item));
            }
            if (Array.isArray(_data["itemDeletions"])) {
                this.itemDeletions = [];
                for (let item of _data["itemDeletions"])
                    this.itemDeletions.push(ItemDeletion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlacementSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.preplacedFurnishings)) {
            data["preplacedFurnishings"] = [];
            for (let item of this.preplacedFurnishings)
                data["preplacedFurnishings"].push(item.toJSON());
        }
        if (Array.isArray(this.itemDeletions)) {
            data["itemDeletions"] = [];
            for (let item of this.itemDeletions)
                data["itemDeletions"].push(item.toJSON());
        }
        return data;
    }
}
export class PreplacedFurnishing {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tag = _data["tag"];
            this.floor = _data["floor"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
            this.positionZ = _data["positionZ"];
            this.rotationX = _data["rotationX"];
            this.rotationY = _data["rotationY"];
            this.rotationZ = _data["rotationZ"];
            this.scaleX = _data["scaleX"];
            this.scaleY = _data["scaleY"];
            this.scaleZ = _data["scaleZ"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PreplacedFurnishing();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["floor"] = this.floor;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        data["positionZ"] = this.positionZ;
        data["rotationX"] = this.rotationX;
        data["rotationY"] = this.rotationY;
        data["rotationZ"] = this.rotationZ;
        data["scaleX"] = this.scaleX;
        data["scaleY"] = this.scaleY;
        data["scaleZ"] = this.scaleZ;
        return data;
    }
}
export class ItemDeletion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tag = _data["tag"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
            this.positionZ = _data["positionZ"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDeletion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        data["positionZ"] = this.positionZ;
        return data;
    }
}
export class GetPlacementSettingsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.home = _data["home"];
            this.isMaster = _data["isMaster"];
            this.ifcName = _data["ifcName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlacementSettingsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["home"] = this.home;
        data["isMaster"] = this.isMaster;
        data["ifcName"] = this.ifcName;
        return data;
    }
}
export class GetProductReplacementThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.artifactVersion = _data["artifactVersion"];
            this.theme = _data["theme"] ? ProductReplacementTheme.fromJS(_data["theme"]) : undefined;
            if (Array.isArray(_data["newProductTags"])) {
                this.newProductTags = [];
                for (let item of _data["newProductTags"])
                    this.newProductTags.push(item);
            }
            if (Array.isArray(_data["obsoleteProductTags"])) {
                this.obsoleteProductTags = [];
                for (let item of _data["obsoleteProductTags"])
                    this.obsoleteProductTags.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductReplacementThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["artifactVersion"] = this.artifactVersion;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        if (Array.isArray(this.newProductTags)) {
            data["newProductTags"] = [];
            for (let item of this.newProductTags)
                data["newProductTags"].push(item);
        }
        if (Array.isArray(this.obsoleteProductTags)) {
            data["obsoleteProductTags"] = [];
            for (let item of this.obsoleteProductTags)
                data["obsoleteProductTags"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class ProductReplacementTheme {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["materialReplacements"])) {
                this.materialReplacements = [];
                for (let item of _data["materialReplacements"])
                    this.materialReplacements.push(ProductPlacement.fromJS(item));
            }
            if (Array.isArray(_data["brickReplacements"])) {
                this.brickReplacements = [];
                for (let item of _data["brickReplacements"])
                    this.brickReplacements.push(ProductPlacement.fromJS(item));
            }
            if (Array.isArray(_data["furnishingReplacements"])) {
                this.furnishingReplacements = [];
                for (let item of _data["furnishingReplacements"])
                    this.furnishingReplacements.push(ProductMeshReplacement.fromJS(item));
            }
            if (Array.isArray(_data["productReplacements"])) {
                this.productReplacements = [];
                for (let item of _data["productReplacements"])
                    this.productReplacements.push(ProductMeshReplacement.fromJS(item));
            }
            this.roofReplacement = _data["roofReplacement"] ? ProductIdentifier.fromJS(_data["roofReplacement"]) : undefined;
            if (Array.isArray(_data["productIdentifiers"])) {
                this.productIdentifiers = [];
                for (let item of _data["productIdentifiers"])
                    this.productIdentifiers.push(ProductIdentifier.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReplacementTheme();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        if (Array.isArray(this.materialReplacements)) {
            data["materialReplacements"] = [];
            for (let item of this.materialReplacements)
                data["materialReplacements"].push(item.toJSON());
        }
        if (Array.isArray(this.brickReplacements)) {
            data["brickReplacements"] = [];
            for (let item of this.brickReplacements)
                data["brickReplacements"].push(item.toJSON());
        }
        if (Array.isArray(this.furnishingReplacements)) {
            data["furnishingReplacements"] = [];
            for (let item of this.furnishingReplacements)
                data["furnishingReplacements"].push(item.toJSON());
        }
        if (Array.isArray(this.productReplacements)) {
            data["productReplacements"] = [];
            for (let item of this.productReplacements)
                data["productReplacements"].push(item.toJSON());
        }
        data["roofReplacement"] = this.roofReplacement ? this.roofReplacement.toJSON() : undefined;
        if (Array.isArray(this.productIdentifiers)) {
            data["productIdentifiers"] = [];
            for (let item of this.productIdentifiers)
                data["productIdentifiers"].push(item.toJSON());
        }
        return data;
    }
}
export class ProductIdentifier {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tag = _data["tag"];
            this.replacementAssetCallerReferenceKey = _data["replacementAssetCallerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIdentifier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["replacementAssetCallerReferenceKey"] = this.replacementAssetCallerReferenceKey;
        return data;
    }
}
export class ProductPlacement extends ProductIdentifier {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.scope = _data["scope"];
            this.scopeRefinement = _data["scopeRefinement"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPlacement();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["scopeRefinement"] = this.scopeRefinement;
        super.toJSON(data);
        return data;
    }
}
export var ProductReplacementScopeType;
(function (ProductReplacementScopeType) {
    ProductReplacementScopeType[ProductReplacementScopeType["NotSet"] = 0] = "NotSet";
    ProductReplacementScopeType[ProductReplacementScopeType["MasterBedroom"] = 1] = "MasterBedroom";
    ProductReplacementScopeType[ProductReplacementScopeType["Bedroom"] = 2] = "Bedroom";
    ProductReplacementScopeType[ProductReplacementScopeType["Family"] = 3] = "Family";
    ProductReplacementScopeType[ProductReplacementScopeType["Living"] = 4] = "Living";
    ProductReplacementScopeType[ProductReplacementScopeType["Rumpus"] = 5] = "Rumpus";
    ProductReplacementScopeType[ProductReplacementScopeType["Media"] = 6] = "Media";
    ProductReplacementScopeType[ProductReplacementScopeType["Meals"] = 7] = "Meals";
    ProductReplacementScopeType[ProductReplacementScopeType["MealsAndRumpus"] = 8] = "MealsAndRumpus";
    ProductReplacementScopeType[ProductReplacementScopeType["MealsAndLiving"] = 9] = "MealsAndLiving";
    ProductReplacementScopeType[ProductReplacementScopeType["MealsAndFamily"] = 10] = "MealsAndFamily";
    ProductReplacementScopeType[ProductReplacementScopeType["Garage"] = 11] = "Garage";
    ProductReplacementScopeType[ProductReplacementScopeType["Alfresco"] = 12] = "Alfresco";
    ProductReplacementScopeType[ProductReplacementScopeType["Study"] = 13] = "Study";
    ProductReplacementScopeType[ProductReplacementScopeType["Kids"] = 14] = "Kids";
    ProductReplacementScopeType[ProductReplacementScopeType["Robe"] = 15] = "Robe";
    ProductReplacementScopeType[ProductReplacementScopeType["Laundry"] = 16] = "Laundry";
    ProductReplacementScopeType[ProductReplacementScopeType["Entry"] = 17] = "Entry";
    ProductReplacementScopeType[ProductReplacementScopeType["Passage"] = 18] = "Passage";
    ProductReplacementScopeType[ProductReplacementScopeType["Kitchen"] = 19] = "Kitchen";
    ProductReplacementScopeType[ProductReplacementScopeType["Ensuite"] = 20] = "Ensuite";
    ProductReplacementScopeType[ProductReplacementScopeType["Linen"] = 21] = "Linen";
    ProductReplacementScopeType[ProductReplacementScopeType["Pantry"] = 22] = "Pantry";
    ProductReplacementScopeType[ProductReplacementScopeType["Porch"] = 23] = "Porch";
    ProductReplacementScopeType[ProductReplacementScopeType["Bath"] = 24] = "Bath";
    ProductReplacementScopeType[ProductReplacementScopeType["WC"] = 25] = "WC";
    ProductReplacementScopeType[ProductReplacementScopeType["Balcony"] = 26] = "Balcony";
    ProductReplacementScopeType[ProductReplacementScopeType["WalkInLinen"] = 27] = "WalkInLinen";
    ProductReplacementScopeType[ProductReplacementScopeType["Stairwell"] = 28] = "Stairwell";
    ProductReplacementScopeType[ProductReplacementScopeType["Landing"] = 29] = "Landing";
    ProductReplacementScopeType[ProductReplacementScopeType["Gym"] = 30] = "Gym";
    ProductReplacementScopeType[ProductReplacementScopeType["Storeroom"] = 31] = "Storeroom";
    ProductReplacementScopeType[ProductReplacementScopeType["Activity"] = 32] = "Activity";
    ProductReplacementScopeType[ProductReplacementScopeType["Mudroom"] = 33] = "Mudroom";
    ProductReplacementScopeType[ProductReplacementScopeType["OutdoorSpace"] = 34] = "OutdoorSpace";
    ProductReplacementScopeType[ProductReplacementScopeType["WalkInPantry"] = 35] = "WalkInPantry";
    ProductReplacementScopeType[ProductReplacementScopeType["Powder"] = 36] = "Powder";
    ProductReplacementScopeType[ProductReplacementScopeType["Nook"] = 37] = "Nook";
    ProductReplacementScopeType[ProductReplacementScopeType["Storage"] = 38] = "Storage";
    ProductReplacementScopeType[ProductReplacementScopeType["WalkInRobe"] = 39] = "WalkInRobe";
})(ProductReplacementScopeType || (ProductReplacementScopeType = {}));
export var ProductReplacementScopeRefinementType;
(function (ProductReplacementScopeRefinementType) {
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Default"] = 0] = "Default";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number1"] = 1] = "Number1";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number2"] = 2] = "Number2";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number3"] = 3] = "Number3";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number4"] = 4] = "Number4";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number5"] = 5] = "Number5";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number6"] = 6] = "Number6";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number7"] = 7] = "Number7";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number8"] = 8] = "Number8";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["Number9"] = 9] = "Number9";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["GroundFloor"] = 10] = "GroundFloor";
    ProductReplacementScopeRefinementType[ProductReplacementScopeRefinementType["FirstFloor"] = 11] = "FirstFloor";
})(ProductReplacementScopeRefinementType || (ProductReplacementScopeRefinementType = {}));
export class ProductMeshReplacement extends ProductPlacement {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.xAdjustment = _data["xAdjustment"];
            this.yAdjustment = _data["yAdjustment"];
            this.zAdjustment = _data["zAdjustment"];
            this.xRotation = _data["xRotation"];
            this.yRotation = _data["yRotation"];
            this.zRotation = _data["zRotation"];
            this.alignBBLongestSides = _data["alignBBLongestSides"];
            this.bbAlignFront = _data["bbAlignFront"];
            this.bbAlignBack = _data["bbAlignBack"];
            this.bbAlignTop = _data["bbAlignTop"];
            this.bbAlignBase = _data["bbAlignBase"];
            this.bbAlignLeft = _data["bbAlignLeft"];
            this.bbAlignRight = _data["bbAlignRight"];
            this.bbScaleToExistingX = _data["bbScaleToExistingX"];
            this.bbScaleToExistingY = _data["bbScaleToExistingY"];
            this.bbScaleToExistingZ = _data["bbScaleToExistingZ"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMeshReplacement();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["xAdjustment"] = this.xAdjustment;
        data["yAdjustment"] = this.yAdjustment;
        data["zAdjustment"] = this.zAdjustment;
        data["xRotation"] = this.xRotation;
        data["yRotation"] = this.yRotation;
        data["zRotation"] = this.zRotation;
        data["alignBBLongestSides"] = this.alignBBLongestSides;
        data["bbAlignFront"] = this.bbAlignFront;
        data["bbAlignBack"] = this.bbAlignBack;
        data["bbAlignTop"] = this.bbAlignTop;
        data["bbAlignBase"] = this.bbAlignBase;
        data["bbAlignLeft"] = this.bbAlignLeft;
        data["bbAlignRight"] = this.bbAlignRight;
        data["bbScaleToExistingX"] = this.bbScaleToExistingX;
        data["bbScaleToExistingY"] = this.bbScaleToExistingY;
        data["bbScaleToExistingZ"] = this.bbScaleToExistingZ;
        super.toJSON(data);
        return data;
    }
}
export class GetProductReplacementThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.templateName = _data["templateName"];
            this.themeName = _data["themeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductReplacementThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["templateName"] = this.templateName;
        data["themeName"] = this.themeName;
        return data;
    }
}
export class GetVanityConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.vanityConfig = _data["vanityConfig"] ? VanityConfig.fromJS(_data["vanityConfig"]) : undefined;
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetVanityConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["vanityConfig"] = this.vanityConfig ? this.vanityConfig.toJSON() : undefined;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class VanityConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.benchtop = _data["benchtop"] ? Benchtop.fromJS(_data["benchtop"]) : undefined;
            this.cabinet = _data["cabinet"] ? Cabinet.fromJS(_data["cabinet"]) : undefined;
            this.basin = _data["basin"] ? Basin.fromJS(_data["basin"]) : undefined;
            this.tap = _data["tap"] ? Tap.fromJS(_data["tap"]) : undefined;
            this.handles = _data["handles"] ? Handles.fromJS(_data["handles"]) : undefined;
            this.facade = _data["facade"] ? Facade.fromJS(_data["facade"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VanityConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["benchtop"] = this.benchtop ? this.benchtop.toJSON() : undefined;
        data["cabinet"] = this.cabinet ? this.cabinet.toJSON() : undefined;
        data["basin"] = this.basin ? this.basin.toJSON() : undefined;
        data["tap"] = this.tap ? this.tap.toJSON() : undefined;
        data["handles"] = this.handles ? this.handles.toJSON() : undefined;
        data["facade"] = this.facade ? this.facade.toJSON() : undefined;
        return data;
    }
}
export class Benchtop {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.width = _data["width"];
            this.depth = _data["depth"];
            this.thickness = _data["thickness"];
            this.bevel = _data["bevel"];
            this.splashBack = _data["splashBack"] ? SplashBack.fromJS(_data["splashBack"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Benchtop();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["depth"] = this.depth;
        data["thickness"] = this.thickness;
        data["bevel"] = this.bevel;
        data["splashBack"] = this.splashBack ? this.splashBack.toJSON() : undefined;
        return data;
    }
}
export class SplashBack {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.depth = _data["depth"];
            this.cornerType = _data["cornerType"];
            this.cornerRadius = _data["cornerRadius"];
            this.wallTapSpacing = _data["wallTapSpacing"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SplashBack();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["depth"] = this.depth;
        data["cornerType"] = this.cornerType;
        data["cornerRadius"] = this.cornerRadius;
        data["wallTapSpacing"] = this.wallTapSpacing;
        return data;
    }
}
export var CornerType;
(function (CornerType) {
    CornerType["None"] = "none";
    CornerType["Convex"] = "convex";
    CornerType["Concave"] = "concave";
})(CornerType || (CornerType = {}));
export class Cabinet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.depth = _data["depth"];
            this.thickness = _data["thickness"];
            this.elevation = _data["elevation"];
            this.uvScale = _data["uvScale"];
            this.bevel = _data["bevel"];
            this.sideShelves = _data["sideShelves"] ? SideShelves.fromJS(_data["sideShelves"]) : undefined;
            this.bottom = _data["bottom"] ? BottomConfig.fromJS(_data["bottom"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Cabinet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["depth"] = this.depth;
        data["thickness"] = this.thickness;
        data["elevation"] = this.elevation;
        data["uvScale"] = this.uvScale;
        data["bevel"] = this.bevel;
        data["sideShelves"] = this.sideShelves ? this.sideShelves.toJSON() : undefined;
        data["bottom"] = this.bottom ? this.bottom.toJSON() : undefined;
        return data;
    }
}
export class SideShelves {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.typeL = _data["typeL"];
            this.widthL = _data["widthL"];
            this.radiusL = _data["radiusL"];
            this.typeR = _data["typeR"];
            this.widthR = _data["widthR"];
            this.radiusR = _data["radiusR"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SideShelves();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["typeL"] = this.typeL;
        data["widthL"] = this.widthL;
        data["radiusL"] = this.radiusL;
        data["typeR"] = this.typeR;
        data["widthR"] = this.widthR;
        data["radiusR"] = this.radiusR;
        return data;
    }
}
export var SideShelfType;
(function (SideShelfType) {
    SideShelfType["None"] = "none";
    SideShelfType["Covered"] = "covered";
    SideShelfType["Open"] = "open";
})(SideShelfType || (SideShelfType = {}));
export class BottomConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.useFeature = _data["useFeature"];
            this.inset = _data["inset"];
            this.legThickness = _data["legThickness"];
            this.frontLegsBack = _data["frontLegsBack"];
            this.legMaker = _data["legMaker"];
            this.legModel = _data["legModel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BottomConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["useFeature"] = this.useFeature;
        data["inset"] = this.inset;
        data["legThickness"] = this.legThickness;
        data["frontLegsBack"] = this.frontLegsBack;
        data["legMaker"] = this.legMaker;
        data["legModel"] = this.legModel;
        return data;
    }
}
export var BottomType;
(function (BottomType) {
    BottomType["Wall"] = "wall";
    BottomType["Legs"] = "legs";
    BottomType["Kick"] = "kick";
    BottomType["KickSplit"] = "kickSplit";
    BottomType["Waterfall"] = "waterfall";
    BottomType["Embrace"] = "embrace";
})(BottomType || (BottomType = {}));
export class Basin {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.maker = _data["maker"];
            this.model = _data["model"];
            this.cutWidth = _data["cutWidth"];
            this.cutDepth = _data["cutDepth"];
            this.cutHeight = _data["cutHeight"];
            this.cutBevel = _data["cutBevel"];
            this.cutThickness = _data["cutThickness"];
            this.cutType = _data["cutType"];
            this.positionDefault = _data["positionDefault"];
            if (Array.isArray(_data["positionOptions"])) {
                this.positionOptions = [];
                for (let item of _data["positionOptions"])
                    this.positionOptions.push(item);
            }
            this.offsetSideways = _data["offsetSideways"] ? BasinOffsetSidewaysConfig.fromJS(_data["offsetSideways"]) : undefined;
            this.offsetDepth = _data["offsetDepth"] ? BasinOffsetDepthConfig.fromJS(_data["offsetDepth"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Basin();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["maker"] = this.maker;
        data["model"] = this.model;
        data["cutWidth"] = this.cutWidth;
        data["cutDepth"] = this.cutDepth;
        data["cutHeight"] = this.cutHeight;
        data["cutBevel"] = this.cutBevel;
        data["cutThickness"] = this.cutThickness;
        data["cutType"] = this.cutType;
        data["positionDefault"] = this.positionDefault;
        if (Array.isArray(this.positionOptions)) {
            data["positionOptions"] = [];
            for (let item of this.positionOptions)
                data["positionOptions"].push(item);
        }
        data["offsetSideways"] = this.offsetSideways ? this.offsetSideways.toJSON() : undefined;
        data["offsetDepth"] = this.offsetDepth ? this.offsetDepth.toJSON() : undefined;
        return data;
    }
}
export var BasinType;
(function (BasinType) {
    BasinType["Model"] = "model";
    BasinType["Boolean"] = "boolean";
})(BasinType || (BasinType = {}));
export var BasinCutType;
(function (BasinCutType) {
    BasinCutType["Rectangular"] = "rectangular";
    BasinCutType["Cylindrical"] = "cylindrical";
})(BasinCutType || (BasinCutType = {}));
export var BasinPosition;
(function (BasinPosition) {
    BasinPosition["Centre"] = "centre";
    BasinPosition["Left"] = "left";
    BasinPosition["Right"] = "right";
    BasinPosition["Double"] = "double";
})(BasinPosition || (BasinPosition = {}));
export class BasinOffsetSidewaysConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.from = _data["from"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BasinOffsetSidewaysConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["amount"] = this.amount;
        return data;
    }
}
export var BasinOffsetSidewaysFrom;
(function (BasinOffsetSidewaysFrom) {
    BasinOffsetSidewaysFrom["Centre"] = "centre";
})(BasinOffsetSidewaysFrom || (BasinOffsetSidewaysFrom = {}));
export class BasinOffsetDepthConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.from = _data["from"];
            this.default = _data["default"];
            this.whenTapOnBench = _data["whenTapOnBench"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BasinOffsetDepthConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["default"] = this.default;
        data["whenTapOnBench"] = this.whenTapOnBench;
        return data;
    }
}
export var BasinOffsetDepthFrom;
(function (BasinOffsetDepthFrom) {
    BasinOffsetDepthFrom["Centre"] = "centre";
})(BasinOffsetDepthFrom || (BasinOffsetDepthFrom = {}));
export class Tap {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maker = _data["maker"];
            this.model = _data["model"];
            this.position = _data["position"];
            this.offsets = _data["offsets"] ? TapOffsetConfig.fromJS(_data["offsets"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Tap();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["maker"] = this.maker;
        data["model"] = this.model;
        data["position"] = this.position;
        data["offsets"] = this.offsets ? this.offsets.toJSON() : undefined;
        return data;
    }
}
export var TapPosition;
(function (TapPosition) {
    TapPosition["Centre"] = "centre";
    TapPosition["Left"] = "left";
    TapPosition["Right"] = "right";
    TapPosition["Outside"] = "outside";
    TapPosition["Inside"] = "inside";
})(TapPosition || (TapPosition = {}));
export class TapOffsetConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.whenOnWallHeight = _data["whenOnWallHeight"];
            this.whenOnCutBasinOffset = _data["whenOnCutBasinOffset"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TapOffsetConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["whenOnWallHeight"] = this.whenOnWallHeight;
        data["whenOnCutBasinOffset"] = this.whenOnCutBasinOffset;
        return data;
    }
}
export class Handles {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerPull = _data["fingerPull"];
            this.maker = _data["maker"];
            this.model = _data["model"];
            this.drawers = _data["drawers"] ? HandleConfig.fromJS(_data["drawers"]) : undefined;
            this.doorHingeLeft = _data["doorHingeLeft"] ? HandleConfig.fromJS(_data["doorHingeLeft"]) : undefined;
            this.doorHingeRight = _data["doorHingeRight"] ? HandleConfig.fromJS(_data["doorHingeRight"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Handles();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerPull"] = this.fingerPull;
        data["maker"] = this.maker;
        data["model"] = this.model;
        data["drawers"] = this.drawers ? this.drawers.toJSON() : undefined;
        data["doorHingeLeft"] = this.doorHingeLeft ? this.doorHingeLeft.toJSON() : undefined;
        data["doorHingeRight"] = this.doorHingeRight ? this.doorHingeRight.toJSON() : undefined;
        return data;
    }
}
export class HandleConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.edge = _data["edge"];
            this.align = _data["align"];
            this.inset = _data["inset"];
            this.offset = _data["offset"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HandleConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["edge"] = this.edge;
        data["align"] = this.align;
        data["inset"] = this.inset;
        data["offset"] = this.offset;
        return data;
    }
}
export var HandleEdge;
(function (HandleEdge) {
    HandleEdge["Left"] = "left";
    HandleEdge["Right"] = "right";
    HandleEdge["Top"] = "top";
    HandleEdge["Bottom"] = "bottom";
})(HandleEdge || (HandleEdge = {}));
export var HandleAlignment;
(function (HandleAlignment) {
    HandleAlignment["Top"] = "top";
    HandleAlignment["Bottom"] = "bottom";
    HandleAlignment["Left"] = "left";
    HandleAlignment["Right"] = "right";
    HandleAlignment["Middle"] = "middle";
})(HandleAlignment || (HandleAlignment = {}));
export class Facade {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cellStyle = _data["cellStyle"];
            this.insetType = _data["insetType"];
            this.cellSpacing = _data["cellSpacing"];
            this.offsetTop = _data["offsetTop"];
            this.braceHeight = _data["braceHeight"];
            this.cellRecessInset = _data["cellRecessInset"];
            this.cellRecessThickness = _data["cellRecessThickness"];
            this.cellRecessAlignGrain = _data["cellRecessAlignGrain"];
            this.fingerPullSpacing = _data["fingerPullSpacing"];
            this.detailTexture = _data["detailTexture"];
            this.feature = _data["feature"] ? FacadeFeature.fromJS(_data["feature"]) : undefined;
            this.layout = _data["layout"] ? Layout.fromJS(_data["layout"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Facade();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cellStyle"] = this.cellStyle;
        data["insetType"] = this.insetType;
        data["cellSpacing"] = this.cellSpacing;
        data["offsetTop"] = this.offsetTop;
        data["braceHeight"] = this.braceHeight;
        data["cellRecessInset"] = this.cellRecessInset;
        data["cellRecessThickness"] = this.cellRecessThickness;
        data["cellRecessAlignGrain"] = this.cellRecessAlignGrain;
        data["fingerPullSpacing"] = this.fingerPullSpacing;
        data["detailTexture"] = this.detailTexture;
        data["feature"] = this.feature ? this.feature.toJSON() : undefined;
        data["layout"] = this.layout ? this.layout.toJSON() : undefined;
        return data;
    }
}
export var CellStyle;
(function (CellStyle) {
    CellStyle["Flat"] = "flat";
    CellStyle["Recessed"] = "recessed";
})(CellStyle || (CellStyle = {}));
export var InsetType;
(function (InsetType) {
    InsetType["None"] = "none";
    InsetType["Vertical"] = "vertical";
    InsetType["AllButTop"] = "allButTop";
    InsetType["Full"] = "full";
})(InsetType || (InsetType = {}));
export class FacadeFeature {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.curve = _data["curve"];
            this.bandWidth = _data["bandWidth"];
            this.bevelWidth = _data["bevelWidth"];
            this.offsetBack = _data["offsetBack"];
            this.slatCount = _data["slatCount"];
            this.inset = _data["inset"];
            this.width = _data["width"];
            this.depth = _data["depth"];
            this.bevel = _data["bevel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FacadeFeature();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["curve"] = this.curve;
        data["bandWidth"] = this.bandWidth;
        data["bevelWidth"] = this.bevelWidth;
        data["offsetBack"] = this.offsetBack;
        data["slatCount"] = this.slatCount;
        data["inset"] = this.inset;
        data["width"] = this.width;
        data["depth"] = this.depth;
        data["bevel"] = this.bevel;
        return data;
    }
}
export var FeatureType;
(function (FeatureType) {
    FeatureType["None"] = "none";
    FeatureType["VerticalBanding"] = "verticalBanding";
    FeatureType["VerticalSlats"] = "verticalSlats";
    FeatureType["SquareRouting"] = "squareRouting";
})(FeatureType || (FeatureType = {}));
export var CurveType;
(function (CurveType) {
    CurveType["Convex"] = "convex";
    CurveType["Concave"] = "concave";
})(CurveType || (CurveType = {}));
export class Layout {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Layout();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cell"] = this.cell ? this.cell.toJSON() : undefined;
        return data;
    }
}
export class Cell {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["children"])) {
                this.children = [];
                for (let item of _data["children"])
                    this.children.push(Cell.fromJS(item));
            }
            this.type = _data["type"];
            this.direction = _data["direction"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.insetBack = _data["insetBack"];
            this.insetTop = _data["insetTop"];
            this.insetBottom = _data["insetBottom"];
            this.insetLeft = _data["insetLeft"];
            this.insetRight = _data["insetRight"];
            this.underlap = _data["underlap"];
            this.overrideRecessInsetV = _data["overrideRecessInsetV"];
            this.overrideSlatCount = _data["overrideSlatCount"];
            this.overrideHandleInset = _data["overrideHandleInset"];
            this.overrideCellInset = _data["overrideCellInset"];
            this.recessPosition = _data["recessPosition"];
            this.alignment = _data["alignment"];
            this.hinge = _data["hinge"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Cell();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["direction"] = this.direction;
        data["width"] = this.width;
        data["height"] = this.height;
        data["insetBack"] = this.insetBack;
        data["insetTop"] = this.insetTop;
        data["insetBottom"] = this.insetBottom;
        data["insetLeft"] = this.insetLeft;
        data["insetRight"] = this.insetRight;
        data["underlap"] = this.underlap;
        data["overrideRecessInsetV"] = this.overrideRecessInsetV;
        data["overrideSlatCount"] = this.overrideSlatCount;
        data["overrideHandleInset"] = this.overrideHandleInset;
        data["overrideCellInset"] = this.overrideCellInset;
        data["recessPosition"] = this.recessPosition;
        data["alignment"] = this.alignment;
        data["hinge"] = this.hinge;
        return data;
    }
}
export var CellType;
(function (CellType) {
    CellType["Stack"] = "stack";
    CellType["Panel"] = "panel";
    CellType["Space"] = "space";
    CellType["Drawer"] = "drawer";
    CellType["Door"] = "door";
    CellType["Divider"] = "divider";
})(CellType || (CellType = {}));
export var StackDirection;
(function (StackDirection) {
    StackDirection["Horizontal"] = "horizontal";
    StackDirection["Vertical"] = "vertical";
})(StackDirection || (StackDirection = {}));
export var CellInsetType;
(function (CellInsetType) {
    CellInsetType["True"] = "true";
    CellInsetType["False"] = "false";
    CellInsetType["Small"] = "small";
})(CellInsetType || (CellInsetType = {}));
export var RecessPosition;
(function (RecessPosition) {
    RecessPosition["PerCell"] = "perCell";
    RecessPosition["Top"] = "top";
    RecessPosition["Bottom"] = "bottom";
    RecessPosition["Middle"] = "middle";
})(RecessPosition || (RecessPosition = {}));
export var Alignment;
(function (Alignment) {
    Alignment["Left"] = "left";
    Alignment["Centre"] = "centre";
    Alignment["Right"] = "right";
})(Alignment || (Alignment = {}));
export var HingeAlignment;
(function (HingeAlignment) {
    HingeAlignment["Left"] = "left";
    HingeAlignment["Right"] = "right";
})(HingeAlignment || (HingeAlignment = {}));
export class GetVanityConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.vanityConfigName = _data["vanityConfigName"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetVanityConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["vanityConfigName"] = this.vanityConfigName;
        data["version"] = this.version;
        return data;
    }
}
export class ListArtifactsResponse extends PagedResponseOfArtifact {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(Artifact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListArtifactsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.keyName = _data["keyName"];
            this.returnAll = _data["returnAll"];
            this.includeSoftware = _data["includeSoftware"];
            this.isActive = _data["isActive"];
            this.notDeleted = _data["notDeleted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["keyName"] = this.keyName;
        data["returnAll"] = this.returnAll;
        data["includeSoftware"] = this.includeSoftware;
        data["isActive"] = this.isActive;
        data["notDeleted"] = this.notDeleted;
        super.toJSON(data);
        return data;
    }
}
export class ListStyleOptionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleOptions"])) {
                this.styleOptions = [];
                for (let item of _data["styleOptions"])
                    this.styleOptions.push(StyleOption.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleOptionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleOptions)) {
            data["styleOptions"] = [];
            for (let item of this.styleOptions)
                data["styleOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class StyleOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.caption = _data["caption"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            if (Array.isArray(_data["styleOptions"])) {
                this.styleOptions = [];
                for (let item of _data["styleOptions"])
                    this.styleOptions.push(StyleOption.fromJS(item));
            }
            if (Array.isArray(_data["themesToApply"])) {
                this.themesToApply = [];
                for (let item of _data["themesToApply"])
                    this.themesToApply.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caption"] = this.caption;
        data["thumbnailUrl"] = this.thumbnailUrl;
        if (Array.isArray(this.styleOptions)) {
            data["styleOptions"] = [];
            for (let item of this.styleOptions)
                data["styleOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.themesToApply)) {
            data["themesToApply"] = [];
            for (let item of this.themesToApply)
                data["themesToApply"].push(item);
        }
        return data;
    }
}
export class ListStyleOptionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleOptionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}
export class ListVanityConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["vanityConfigs"])) {
                this.vanityConfigs = [];
                for (let item of _data["vanityConfigs"])
                    this.vanityConfigs.push(VanityConfigSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListVanityConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vanityConfigs)) {
            data["vanityConfigs"] = [];
            for (let item of this.vanityConfigs)
                data["vanityConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class VanityConfigSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.productionVersion = _data["productionVersion"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
            this.width = _data["width"];
            this.height = _data["height"];
            this.elevation = _data["elevation"];
            this.wallHung = _data["wallHung"];
            this.basinType = _data["basinType"];
            this.basinMaker = _data["basinMaker"];
            this.tapMaker = _data["tapMaker"];
            this.tapModel = _data["tapModel"];
            this.fingerPull = _data["fingerPull"];
            this.handlesMaker = _data["handlesMaker"];
            this.handlesModel = _data["handlesModel"];
            this.legMaker = _data["legMaker"];
            this.legModel = _data["legModel"];
            this.numberOfDrawers = _data["numberOfDrawers"];
            this.numberOfDoors = _data["numberOfDoors"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VanityConfigSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["version"] = this.version;
        data["productionVersion"] = this.productionVersion;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        data["elevation"] = this.elevation;
        data["wallHung"] = this.wallHung;
        data["basinType"] = this.basinType;
        data["basinMaker"] = this.basinMaker;
        data["tapMaker"] = this.tapMaker;
        data["tapModel"] = this.tapModel;
        data["fingerPull"] = this.fingerPull;
        data["handlesMaker"] = this.handlesMaker;
        data["handlesModel"] = this.handlesModel;
        data["legMaker"] = this.legMaker;
        data["legModel"] = this.legModel;
        data["numberOfDrawers"] = this.numberOfDrawers;
        data["numberOfDoors"] = this.numberOfDoors;
        return data;
    }
}
export class ListVanityConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListVanityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        return data;
    }
}
export class ListVanityConfigVersionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["versions"])) {
                this.versions = [];
                for (let item of _data["versions"])
                    this.versions.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListVanityConfigVersionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListVanityConfigVersionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.vanityConfigName = _data["vanityConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListVanityConfigVersionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["vanityConfigName"] = this.vanityConfigName;
        return data;
    }
}
export class ListStyleChoicesConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleChoicesConfigs"])) {
                this.styleChoicesConfigs = [];
                for (let item of _data["styleChoicesConfigs"])
                    this.styleChoicesConfigs.push(StyleChoicesConfigSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleChoicesConfigs)) {
            data["styleChoicesConfigs"] = [];
            for (let item of this.styleChoicesConfigs)
                data["styleChoicesConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class StyleChoicesConfigSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleChoicesConfigSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        return data;
    }
}
export class ListStyleChoicesConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["productName"] = this.productName;
        return data;
    }
}
export class ListStyleChoicesConfigVersionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["versions"])) {
                this.versions = [];
                for (let item of _data["versions"])
                    this.versions.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesConfigVersionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListStyleChoicesConfigVersionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.productName = _data["productName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesConfigVersionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["productName"] = this.productName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        return data;
    }
}
export class GetStyleChoicesConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.styleChoicesConfig = _data["styleChoicesConfig"] ? StyleChoicesConfig.fromJS(_data["styleChoicesConfig"]) : undefined;
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleChoicesConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleChoicesConfig"] = this.styleChoicesConfig ? this.styleChoicesConfig.toJSON() : undefined;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class StyleChoicesConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [];
                for (let item of _data["choices"])
                    this.choices.push(StyleChoice.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleChoicesConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}
export class StyleChoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.choice = _data["choice"] ? StyleChoice.fromJS(_data["choice"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleChoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["choice"] = this.choice ? this.choice.toJSON() : undefined;
        return data;
    }
}
export class GetStyleChoicesConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.productName = _data["productName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleChoicesConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["productName"] = this.productName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        data["version"] = this.version;
        return data;
    }
}
export class DeleteVanityConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVanityConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteVanityConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.vanityConfigName = _data["vanityConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVanityConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["vanityConfigName"] = this.vanityConfigName;
        return data;
    }
}
export class SaveFacadeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFacadeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class SaveFacadeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.facadeConfig = _data["facadeConfig"] ? FacadeConfig.fromJS(_data["facadeConfig"]) : undefined;
            this.isProduction = _data["isProduction"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFacadeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["facadeConfig"] = this.facadeConfig ? this.facadeConfig.toJSON() : undefined;
        data["isProduction"] = this.isProduction;
        return data;
    }
}
export class DeleteFacadeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFacadeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteFacadeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.facadeConfigName = _data["facadeConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFacadeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["facadeConfigName"] = this.facadeConfigName;
        return data;
    }
}
export class SaveIfcSettingsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIfcSettingsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        super.toJSON(data);
        return data;
    }
}
export class SaveIfcSettingsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.latestArtifactId = _data["latestArtifactId"];
            this.settings = _data["settings"] ? IfcToJsonSettings.fromJS(_data["settings"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIfcSettingsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["latestArtifactId"] = this.latestArtifactId;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        return data;
    }
}
export class SavePlacementSettingsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlacementSettingsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        super.toJSON(data);
        return data;
    }
}
export class SavePlacementSettingsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.home = _data["home"];
            this.isMaster = _data["isMaster"];
            this.ifcName = _data["ifcName"];
            this.settings = _data["settings"] ? PlacementSettings.fromJS(_data["settings"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlacementSettingsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["home"] = this.home;
        data["isMaster"] = this.isMaster;
        data["ifcName"] = this.ifcName;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        return data;
    }
}
export class SaveProductReplacementThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.artifactVersion = _data["artifactVersion"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductReplacementThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["artifactVersion"] = this.artifactVersion;
        super.toJSON(data);
        return data;
    }
}
export class SaveProductReplacementThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.templateName = _data["templateName"];
            this.themeName = _data["themeName"];
            this.theme = _data["theme"] ? ProductReplacementTheme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductReplacementThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["templateName"] = this.templateName;
        data["themeName"] = this.themeName;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        return data;
    }
}
export class SaveVanityConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveVanityConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class SaveVanityConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.vanityConfig = _data["vanityConfig"] ? VanityConfig.fromJS(_data["vanityConfig"]) : undefined;
            this.isProduction = _data["isProduction"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveVanityConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["vanityConfig"] = this.vanityConfig ? this.vanityConfig.toJSON() : undefined;
        data["isProduction"] = this.isProduction;
        return data;
    }
}
export class SaveStyleChoicesConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleChoicesConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class SaveStyleChoicesConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.productName = _data["productName"];
            this.styleChoicesConfig = _data["styleChoicesConfig"] ? StyleChoicesConfig.fromJS(_data["styleChoicesConfig"]) : undefined;
            this.isProduction = _data["isProduction"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleChoicesConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["productName"] = this.productName;
        data["styleChoicesConfig"] = this.styleChoicesConfig ? this.styleChoicesConfig.toJSON() : undefined;
        data["isProduction"] = this.isProduction;
        return data;
    }
}
export class DeleteStyleChoicesConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStyleChoicesConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteStyleChoicesConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.productName = _data["productName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStyleChoicesConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["productName"] = this.productName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
